export const resources = {
  en: {
    translation: {
      welcome: 'Welcome',
    },
  },
};